import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addErrorNotification } from './notificationsSlice';

const initialState = {
  upgradeRequest: null,
};

// ---------------------- ASYNC THUNKS ----------------------

export const getAccountUpgradeRequest = createAsyncThunk(
  'normalUserHome/getAccountUpgradeRequest',
  async (_, thunkAPI) => {
    const res = await requests.getAccountUpgradeRequest();
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Fetching The Account Upgrade Status!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

export const executeAccountUpgradeRequest = createAsyncThunk(
  'normalUserHome/executeAccountUpgradeRequest',
  async ({ accountType, entityName, sector, sectorName }, thunkAPI) => {
    const res = await requests.requestUpgradeAccount(
      accountType,
      entityName,
      sector,
      sectorName
    );
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Request to Upgrade Account!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const normalUserHomeSlice = createSlice({
  name: 'normalUserHome',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAccountUpgradeRequest.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.upgradeRequest = payload.body.upgradeRequest;
        }
      })
      .addCase(executeAccountUpgradeRequest.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.upgradeRequest = payload.body.upgradeRequest;
        }
      });
  },
});

export default normalUserHomeSlice.reducer;
